export default __webpack_public_path__ + "static/media/bg1.71a28027.jpg";